import axios from 'axios';
import { conf } from '../../utils';
import { getToken } from './index';
import HTTPError from '../HTTPError';

export const markets = {
  getMarkets: async () => {
    const url = conf('apiUrl') + '/markets';
    try {
      const res = await axios.get(url, { headers: { Authorization: getToken() } });
      return res.data;
    } catch (err) {
      console.error(err);
      return false;
    }
  },
  getMarketById: async market => {
    const url = conf('apiUrl') + '/markets/' + market;
    try {
      const res = await axios.get(url, { headers: { Authorization: getToken() } });
      return res.data;
    } catch (err) {
      console.error(err);
      return false;
    }
  },
  getMetricsById: async market => {
    const url = conf('apiUrl') + '/markets/' + market + '/metrics';
    try {
      const res = await axios.get(url, { headers: { Authorization: getToken() } });
      return res.data;
    } catch (err) {
      console.error(err);
      return false;
    }
  },
  getOrders: async (market, type) => {
    const url = conf('apiUrl') + '/markets/' + market + '/orders/' + type;
    try {
      const res = await axios.get(url, { headers: { Authorization: getToken() } });
      return res.data;
    } catch (err) {
      console.error(err);
      return false;
    }
  },
  getHistory: async market => {
    const url = conf('apiUrl') + '/markets/history';
    try {
      const res = await axios.get(url, { headers: { Authorization: getToken() } });
      return res.data;
    } catch (err) {
      console.error(err);
      return false;
    }
  },
  getHistoryByMarket: async market => {
    const url = conf('apiUrl') + '/markets/' + market + '/history';
    try {
      const res = await axios.get(url, { headers: { Authorization: getToken() } });
      return res.data;
    } catch (err) {
      console.error(err);
      return false;
    }
  },
  postOrder: async (market, type, amount, price) => {
    const url = conf('apiUrl') + '/markets/' + market + '/orders';
    const body = {
      type: type === 'Buy' ? 'buy' : 'sell',
      amount, price
    }

    try {
      const res = await axios.post(url, body, { headers: { Authorization: getToken() } });
      return res.data;
    } catch (err) {
      console.error(err);
      return false;
    }
  }
}
